import { useUserHasAnyPermissions } from "../_helpers/permissions";

const useCareEpisodesFlag = () => {
  const isEpisodesOfCareBetaUser = useUserHasAnyPermissions(["IsCareEpisodesUser"]);
  
  return isEpisodesOfCareBetaUser;
};

export default useCareEpisodesFlag;
